import { render, staticRenderFns } from "./pgsignForm.vue?vue&type=template&id=38169ea8&scoped=true"
import script from "./pgsignForm.vue?vue&type=script&lang=js"
export * from "./pgsignForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38169ea8",
  null
  
)

export default component.exports